import { SVGIconComponent } from './types';

export const OverdueStatusCircle: SVGIconComponent = () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Status-indicator/overdue" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval-Copy" fill="#E57401" cx="7" cy="7" r="7"></circle>
    </g>
  </svg>
);
